// 取り込み系 (ファイル取り込み / visa 一括同期) で共通のマスタ突合ルール。
// 名称は「表記ゆれがある前提」で突合する: NFKC で全角英数字・全角記号 (（） ・ － 等) を半角へ寄せ、
// 空白を除去し、英字は大文字へ寄せてから比較する。ファイル入力・visa の値どちらにも同じ規則を適用する。

import { TOption } from "@/types/common";

// Excel / Web からのコピペで混入する不可視文字 (ゼロ幅スペース・BOM 等) は \s に含まれないため個別に除去する。
const INVISIBLE_CHARS = /[\u200B-\u200D\u2060\uFEFF]/g;

export const normalizeMasterLabel = (value: string): string =>
  value.normalize("NFKC").replace(INVISIBLE_CHARS, "").replace(/[\s　]/g, "").toUpperCase();

// 表示名からマスタの選択肢を引く。空文字は突合しない (未入力を先頭の選択肢に寄せないため)。
export const findOptionByLabel = (options: TOption[], value?: string | null): TOption | undefined => {
  if (!value) return undefined;
  const key = normalizeMasterLabel(value);
  return options.find((opt) => normalizeMasterLabel(opt.label) === key);
};
